
import styled from 'styled-components';
import TrackingComponent from '../components/Tracking/TrackingComponent';
import GetStartedRequestDemoSide from '../components/generic/GetStartedRequestDemoSide';

import PlatformMobileIntro from '../components/PlatformMobile/PlatformMobileIntro';
import PlatformMobileData from '../components/PlatformMobile/PlatformMobileData';
import PlatformMobileBanner from '../components/PlatformMobile/PlatformMobileBanner';
import AppGrowMostBenefits from '../components/AppGrow/AppGrowMostBenefits';
import { lightThemeColors } from '../assets/style/colors';
import { ReactComponent as GridAssetIcon } from "../assets/decorations/blueBannerGrid.svg";
import { Helmet } from 'react-helmet-async';

const PlatformMobilePage = () => {
    return (
        <>
            <Helmet>
                <title>Mobile App Growth & User Engagement | Grovs</title>
                <meta
                    name="description"
                    content="Grow your mobile app faster with Grovs. Track installs, boost engagement, optimize ROI, and deliver seamless user journeys on iOS and Android."
                />
                <meta
                    name="keywords"
                    content="mobile app growth, user engagement, app installs, deep linking, automated messaging, ROI optimization, app retention"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Mobile App Growth & User Engagement with Grovs"
                />
                <meta
                    property="og:description"
                    content="Drive installs, maximize engagement, and improve ROI with precise tracking and automated messaging for mobile apps on iOS and Android."
                />
                <meta property="og:url" content="https://www.grovs.io/platform-mobile" />
                <meta
                    property="og:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/mobile-growth-social.jpg"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Mobile App Growth & User Engagement | Grovs"
                />
                <meta
                    name="twitter:description"
                    content="Boost installs, retain users, and optimize your mobile campaigns with Grovs’ deep linking and automated messaging."
                />
                <meta
                    name="twitter:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/mobile-growth-social.jpg"
                />
            </Helmet>
            <Container>
                <PlatformMobileIntro />
                <PlatformMobileData />
                <PlatformMobileBanner />
                <AppGrowMostBenefits />
                <GetStartedRequestDemoSide
                    bgColor={lightThemeColors.measureBg}
                    gradientColor={"rgba(91, 104, 223, 1)"}
                    titleStyle={{ color: lightThemeColors.lightColor }}
                    subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
                    gridDecoration={<GridAssetIcon />}
                    primaryButtonStyle={{ color: lightThemeColors.lightColor }}
                    primaryButtonVariant={lightThemeColors.footerBg}
                    outlineButtonStyle={{ color: lightThemeColors.darkColor, background: lightThemeColors.lightColor }}
                    outlineButtonVariant={lightThemeColors.lightColor}
                    title={"Ready to Scale Your Mobile App?"}
                    subtitle={"Join the leading brands using Grovs to drive installs, maximize engagement, and clearly measure results. Stop guessing and start growing with confidence."}
                />
                <TrackingComponent />
            </Container>
        </>
    )
}

export default PlatformMobilePage

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;